"use strict";
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import io, { Socket } from "socket.io-client";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MetricsDashboard;
// /**
//  * ✅ Quick start
//  * 1) npm i socket.io-client recharts
//  * 2) .env
//  *    VITE_SOCKET_URL=https://sunuautoroute.volkeno.com:6002
//  * 3) <MetricsDashboard /> somewhere in your React app
//  * 4) Ensure the Socket.IO server emits `metrics:snapshot` every 5s
//  *
//  *    io.emit('metrics:snapshot', { ts: Date.now(), connections, roomsCount })
//  */
// // ---- Types ----
// interface Snapshot {
//   ts: number;
//   connections: number;
//   roomsCount: number;
// }
// // ---- Small helpers ----
// function formatClock(ts: number) {
//   try {
//     return new Date(ts).toLocaleTimeString();
//   } catch {
//     return String(ts);
//   }
// }
// // ---- UI atoms ----
// function StatCard({ label, value, sub }: { label: string; value: number | string; sub?: string }) {
//   return (
//     <div className="item-stat-dashboad-view shadow" style={{ height: '100%' }}>
//       <div className="text-xs uppercase tracking-wide text-zinc-500">{label}</div>
//       <div className="text-4xl font-semibold mt-1">{value}</div>
//       {sub ? <div className="text-xs text-zinc-500 mt-1">{sub}</div> : null}
//     </div>
//   );
// }
// function Badge({ children, tone = "ok" }: { children: React.ReactNode; tone?: "ok" | "warn" | "err" }) {
//   const toneClass =
//     tone === "ok"
//       ? "bg-success-subtle text-success"
//       : tone === "warn"
//       ? "bg-warning-subtle text-warning"
//       : "bg-danger-subtle text-danger";
//   return <span className={`px-3 py-2 badge rounded-pill ${toneClass}`}>{children}</span>;
// }
// // ---- Main component ----
// export default function MetricsDashboard() {
//   const [data, setData] = useState<Snapshot[]>([]);
//   const [status, setStatus] = useState<"connecting" | "connected" | "disconnected">("connecting");
//   const socketRef = useRef<Socket | null>(null);
//   useEffect(() => {
//     const socket = io('https://sunuautoroute.volkeno.com:6002', {
//       path: "/socket.io",
//       transports: ["websocket", "polling"],
//       withCredentials: true,
//       secure: true,
//       reconnection: true,
//       reconnectionAttempts: 10,
//       reconnectionDelay: 1000,
//     });
//     socketRef.current = socket;
//     socket.on("connect", () => setStatus("connected"));
//     socket.on("disconnect", () => setStatus("disconnected"));
//     socket.on("connect_error", () => setStatus("disconnected"));
//     socket.on("metrics:snapshot", (snap: Snapshot) => {
//       setData((prev) => {
//         const next = [...prev, snap];
//         // keep last 200 points
//         if (next.length > 200) next.shift();
//         return next;
//       });
//     });
//     return () => {
//       socket.off("metrics:snapshot");
//       socket.close();
//     };
//   }, []);
//   const last = data[data.length - 1];
//   const rates = useMemo(() => {
//     // Rough per-minute rate based on last N points (5s interval assumed)
//     const N = Math.min(data.length, 12); // ~60s window
//     if (N < 2) return { connDelta: 0, roomsDelta: 0 };
//     const start = data[data.length - N];
//     const end = data[data.length - 1];
//     const secs = (end.ts - start.ts) / 1000;
//     const perMin = (v: number) => (secs > 0 ? (v * 60) / secs : 0);
//     return {
//       connDelta: perMin(end.connections - start.connections),
//       roomsDelta: perMin(end.roomsCount - start.roomsCount),
//     };
//   }, [data]);
//   return (
//     <div className="dashbord-admin-component">
//         <div className="dash-admin-page-content-container mb-3">
//             <div className="container-fluid">
//                 <div className="row">
//                     <div className="col-lg-12">
//                         <div className="sub-title-page-admin pb-3">
//                           Socket.IO – Metrics live
//                         </div>
//                         <div className="row mt-5">
//                           <div className="col-lg-12 sunu-autoroute-admin-titre-page-container mb-3">
//                             <div className="admin-titre-page">
//                               Socket.IO – Metrics live
//                             </div>
//                           </div>
//                           <p className="text-sm text-zinc-500">Écoute l'événement <code>metrics:snapshot</code> émis par le serveur.</p>
//                         </div>
//                         <div className="">
//                           <div>
//                             {status === "connected" && <Badge>Connecté</Badge>}
//                             {status === "connecting" && <Badge tone="warn">Connexion…</Badge>}
//                             {status === "disconnected" && <Badge tone="err">Hors ligne</Badge>}
//                           </div>
//                         </div>
//                         <section className="pt-3 section">
//                           <div className="row">
//                             <div className="col-lg-4 col-md-6 mb-3">
//                               <StatCard label="Connexions actives" value={last?.connections ?? 0} sub={last ? `à ${formatClock(last.ts)}` : "—"} />
//                             </div>
//                             <div className="col-lg-4 col-md-6 mb-3">
//                               <StatCard label="Rooms" value={last?.roomsCount ?? 0} sub={last ? `à ${formatClock(last.ts)}` : "—"} />
//                             </div>
//                             <div className="col-lg-4 col-md-6 mb-3">
//                               <StatCard label="Variation/min" value={`${rates.connDelta.toFixed(1)} conn · ${rates.roomsDelta.toFixed(1)} rooms`} />
//                             </div>
//                           </div>
//                         </section>
//                         <section className="rounded-3 shadow p-3 bg-white border border-light">
//                           <div className="flex items-center justify-between mb-2">
//                             <h2 className="text-lg font-medium">Historique (derniers {data.length} points)</h2>
//                             <div className="text-xs text-zinc-500">Intervalle serveur: 5s</div>
//                           </div>
//                           <div style={{ width: "100%", height: 320 }}>
//                             <ResponsiveContainer>
//                               <LineChart data={data} margin={{ top: 10, right: 20, bottom: 0, left: 0 }}>
//                                 <CartesianGrid strokeDasharray="3 3" />
//                                 <XAxis dataKey="ts" tickFormatter={formatClock} minTickGap={20} />
//                                 <YAxis allowDecimals={false} />
//                                 <Tooltip labelFormatter={(v) => formatClock(Number(v))} />
//                                 <Legend />
//                                 <Line type="monotone" dataKey="connections" name="Connexions" dot={false} strokeWidth={2} />
//                                 <Line type="monotone" dataKey="roomsCount" name="Rooms" dot={false} strokeWidth={2} />
//                               </LineChart>
//                             </ResponsiveContainer>
//                           </div>
//                         </section>
//                         <section className="rounded-3 shadow p-3 bg-white border card-glass mt-4">
//                           <h3 className="text-base font-medium mb-3">Derniers snapshots</h3>
//                           <div className="overflow-auto max-h-72">
//                             <table className="min-w-full text-sm">
//                               <thead>
//                                 <tr className="text-left text-zinc-500">
//                                   <th className="py-2 pr-3">Horodatage</th>
//                                   <th className="py-2 pr-3">Connexions</th>
//                                   <th className="py-2 pr-3">Rooms</th>
//                                 </tr>
//                               </thead>
//                               <tbody>
//                                 {data
//                                   .slice()
//                                   .reverse()
//                                   .map((s) => (
//                                     <tr key={s.ts} className="border-t border-zinc-200/60 dark:border-zinc-800/80">
//                                       <td className="py-2 pr-3">{formatClock(s.ts)}</td>
//                                       <td className="py-2 pr-3">{s.connections}</td>
//                                       <td className="py-2 pr-3">{s.roomsCount}</td>
//                                     </tr>
//                                   ))}
//                               </tbody>
//                             </table>
//                           </div>
//                         </section>
//                         <div className="table--wrapper">
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>
//   );
// }
const react_1 = __importStar(require("react"));
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const recharts_1 = require("recharts");
// ---- Small helpers ----
function formatClock(ts) {
    try {
        return new Date(ts).toLocaleTimeString();
    }
    catch (_a) {
        return String(ts);
    }
}
function humanUptime(sec) {
    if (!sec && sec !== 0)
        return "—";
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = Math.floor(sec % 60);
    return `${h}h ${m}m ${s}s`;
}
function p95(values) {
    if (!values.length)
        return 0;
    const arr = [...values].sort((a, b) => a - b);
    const idx = Math.ceil(0.95 * arr.length) - 1;
    return arr[Math.max(0, idx)];
}
function approxSize(event, args) {
    try {
        const payload = args.length === 1 ? args[0] : args;
        const json = JSON.stringify(payload);
        // event name + payload JSON ~octets
        return ((event === null || event === void 0 ? void 0 : event.length) || 0) + ((json === null || json === void 0 ? void 0 : json.length) || 0);
    }
    catch (_a) {
        return ((event === null || event === void 0 ? void 0 : event.length) || 0);
    }
}
// ---- UI atoms ----
function StatCard({ label, value, sub }) {
    return (react_1.default.createElement("div", { className: "item-stat-dashboad-view shadow", style: { height: '100%' } },
        react_1.default.createElement("div", { className: "text-xs uppercase tracking-wide text-zinc-500" }, label),
        react_1.default.createElement("div", { className: "text-4xl font-semibold mt-1" }, value),
        sub ? react_1.default.createElement("div", { className: "text-xs text-zinc-500 mt-1" }, sub) : null));
}
function Badge({ children, tone = "ok" }) {
    const toneClass = tone === "ok"
        ? "bg-success-subtle text-success"
        : tone === "warn"
            ? "bg-warning-subtle text-warning"
            : "bg-danger-subtle text-danger";
    return react_1.default.createElement("span", { className: `px-3 py-2 badge rounded-pill ${toneClass}` }, children);
}
// ---- Main component ----
function MetricsDashboard() {
    var _a, _b, _c, _d, _e, _f;
    const [data, setData] = (0, react_1.useState)([]);
    const [status, setStatus] = (0, react_1.useState)("connecting");
    const socketRef = (0, react_1.useRef)(null);
    // fenêtres glissantes pour RTT et octets
    const rttWindow = (0, react_1.useRef)([]); // derniers RTT (ms) ~ 12 points (1 min)
    const rxWindow = (0, react_1.useRef)([]);
    const txWindow = (0, react_1.useRef)([]);
    // monkey patch emit pour compter les octets sortants
    const patchEmit = (socket) => {
        const orig = socket.emit.bind(socket);
        socket.emit = ((event, ...args) => {
            try {
                const bytes = approxSize(event, args);
                txWindow.current.push({ ts: Date.now(), bytes });
            }
            catch (_a) { }
            return orig(event, ...args);
        });
    };
    (0, react_1.useEffect)(() => {
        const base = 'https://sunuautoroute.volkeno.com:6002';
        const socket = (0, socket_io_client_1.default)(base, {
            path: "/socket.io",
            transports: ["websocket", "polling"],
            withCredentials: true,
            secure: true,
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 1000,
        });
        patchEmit(socket);
        socketRef.current = socket;
        socket.on("connect", () => setStatus("connected"));
        socket.on("disconnect", () => setStatus("disconnected"));
        socket.on("connect_error", () => setStatus("disconnected"));
        // compter octets entrants
        socket.onAny((event, ...args) => {
            const bytes = approxSize(event, args);
            rxWindow.current.push({ ts: Date.now(), bytes });
        });
        socket.on("metrics:snapshot", (snap) => {
            // enrichir avec RTT/throughput calculés côté client
            const enriched = attachNetMetrics(snap, rttWindow.current, rxWindow.current, txWindow.current);
            setData((prev) => {
                const next = [...prev, enriched];
                if (next.length > 200)
                    next.shift();
                return next;
            });
        });
        // PING/PONG périodique (5s)
        const pingInterval = setInterval(() => {
            if (socket.connected) {
                const pad = "x".repeat(256); // charge utile pour simuler du trafic (256B)
                const t0 = Date.now();
                socket.emit("metrics:ping", { t0, pad });
            }
        }, 5000);
        // Réponse pong → calcul RTT
        socket.on("metrics:pong", (m) => {
            if (!(m === null || m === void 0 ? void 0 : m.t0))
                return;
            const rtt = Date.now() - m.t0;
            const arr = rttWindow.current;
            arr.push(rtt);
            // garder ~1 min de RTT (12 points @5s)
            if (arr.length > 12)
                arr.shift();
        });
        return () => {
            clearInterval(pingInterval);
            socket.off("metrics:snapshot");
            socket.off("metrics:pong");
            socket.close();
        };
    }, []);
    const last = data[data.length - 1];
    const rates = (0, react_1.useMemo)(() => {
        // Rough per-minute delta based on last N points (5s interval assumed)
        const N = Math.min(data.length, 12); // ~60s window
        if (N < 2)
            return { connDelta: 0, roomsDelta: 0 };
        const start = data[data.length - N];
        const end = data[data.length - 1];
        const secs = (end.ts - start.ts) / 1000;
        const perMin = (v) => (secs > 0 ? (v * 60) / secs : 0);
        return {
            connDelta: perMin(end.connections - start.connections),
            roomsDelta: perMin(end.roomsCount - start.roomsCount),
        };
    }, [data]);
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Socket.IO \u2013 Metrics live"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-titre-page" }, "Socket.IO \u2013 Metrics live")),
                            react_1.default.createElement("p", { className: "text-sm text-zinc-500" },
                                "\u00C9coute l'\u00E9v\u00E9nement ",
                                react_1.default.createElement("code", null, "metrics:snapshot"),
                                " et ajoute ",
                                react_1.default.createElement("code", null, "metrics:ping/pong"),
                                " pour RTT & d\u00E9bit.")),
                        react_1.default.createElement("div", { className: "mb-3" },
                            status === "connected" && react_1.default.createElement(Badge, null, "Connect\u00E9"),
                            status === "connecting" && react_1.default.createElement(Badge, { tone: "warn" }, "Connexion\u2026"),
                            status === "disconnected" && react_1.default.createElement(Badge, { tone: "err" }, "Hors ligne")),
                        react_1.default.createElement("section", { className: "pt-3 section" },
                            react_1.default.createElement("div", { className: "row" },
                                react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3" },
                                    react_1.default.createElement(StatCard, { label: "Connexions actives", value: (_a = last === null || last === void 0 ? void 0 : last.connections) !== null && _a !== void 0 ? _a : 0, sub: last ? `à ${formatClock(last.ts)}` : "—" })),
                                react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3" },
                                    react_1.default.createElement(StatCard, { label: "Rooms", value: (_b = last === null || last === void 0 ? void 0 : last.roomsCount) !== null && _b !== void 0 ? _b : 0, sub: last ? `à ${formatClock(last.ts)}` : "—" })),
                                react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3" },
                                    react_1.default.createElement(StatCard, { label: "Namespaces", value: (_c = last === null || last === void 0 ? void 0 : last.namespacesCount) !== null && _c !== void 0 ? _c : '—', sub: "io.of() actifs" })),
                                react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3" },
                                    react_1.default.createElement(StatCard, { label: "Events/min", value: (_d = last === null || last === void 0 ? void 0 : last.eventsPerMin) !== null && _d !== void 0 ? _d : '—', sub: "fen\u00EAtre ~60s" }))),
                            react_1.default.createElement("div", { className: "row" },
                                react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3" },
                                    react_1.default.createElement(StatCard, { label: "RTT moyen", value: (last === null || last === void 0 ? void 0 : last.rttAvgMs) ? `${last.rttAvgMs.toFixed(0)} ms` : '—', sub: "ping/pong" })),
                                react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3" },
                                    react_1.default.createElement(StatCard, { label: "RTT p95", value: (last === null || last === void 0 ? void 0 : last.rttP95Ms) ? `${last.rttP95Ms.toFixed(0)} ms` : '—', sub: "ping/pong" })),
                                react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3" },
                                    react_1.default.createElement(StatCard, { label: "Rx", value: (last === null || last === void 0 ? void 0 : last.rxKbps) ? `${last.rxKbps.toFixed(1)} kb/s` : '—', sub: "~1 min" })),
                                react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3" },
                                    react_1.default.createElement(StatCard, { label: "Tx", value: (last === null || last === void 0 ? void 0 : last.txKbps) ? `${last.txKbps.toFixed(1)} kb/s` : '—', sub: "~1 min" })))),
                        react_1.default.createElement("section", { className: "rounded-3 shadow p-3 bg-white border border-light" },
                            react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between mb-2" },
                                react_1.default.createElement("h2", { className: "h6 m-0" },
                                    "Historique (derniers ",
                                    data.length,
                                    " points)"),
                                react_1.default.createElement("div", { className: "text-xs text-zinc-500" }, "Intervalle serveur: 5s")),
                            react_1.default.createElement("div", { style: { width: "100%", height: 320 } },
                                react_1.default.createElement(recharts_1.ResponsiveContainer, null,
                                    react_1.default.createElement(recharts_1.LineChart, { data: data, margin: { top: 10, right: 20, bottom: 0, left: 0 } },
                                        react_1.default.createElement(recharts_1.CartesianGrid, { strokeDasharray: "3 3" }),
                                        react_1.default.createElement(recharts_1.XAxis, { dataKey: "ts", tickFormatter: formatClock, minTickGap: 20 }),
                                        react_1.default.createElement(recharts_1.YAxis, { allowDecimals: false }),
                                        react_1.default.createElement(recharts_1.Tooltip, { labelFormatter: (v) => formatClock(Number(v)) }),
                                        react_1.default.createElement(recharts_1.Legend, null),
                                        react_1.default.createElement(recharts_1.Line, { type: "monotone", dataKey: "connections", name: "Connexions", dot: false, strokeWidth: 2 }),
                                        react_1.default.createElement(recharts_1.Line, { type: "monotone", dataKey: "roomsCount", name: "Rooms", dot: false, strokeWidth: 2 }))))),
                        react_1.default.createElement("section", { className: "rounded-3 shadow p-3 bg-white border card-glass mt-4" },
                            react_1.default.createElement("h3", { className: "h6 mb-3" }, "Top rooms (non priv\u00E9es)"),
                            react_1.default.createElement("div", { className: "table-responsive" },
                                react_1.default.createElement("table", { className: "table table-sm" },
                                    react_1.default.createElement("thead", null,
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null, "Room"),
                                            react_1.default.createElement("th", null, "Taille"))),
                                    react_1.default.createElement("tbody", null,
                                        ((_e = last === null || last === void 0 ? void 0 : last.topRooms) !== null && _e !== void 0 ? _e : []).map((r) => (react_1.default.createElement("tr", { key: r.room },
                                            react_1.default.createElement("td", null,
                                                react_1.default.createElement("code", null, r.room)),
                                            react_1.default.createElement("td", null, r.size)))),
                                        (!(last === null || last === void 0 ? void 0 : last.topRooms) || last.topRooms.length === 0) && (react_1.default.createElement("tr", null,
                                            react_1.default.createElement("td", { colSpan: 2, className: "text-muted" }, "\u2014"))))))),
                        react_1.default.createElement("section", { className: "rounded-3 shadow p-3 bg-white border card-glass mt-4 mb-5" },
                            react_1.default.createElement("h3", { className: "h6 mb-3" }, "Top events (fen\u00EAtre ~60s)"),
                            react_1.default.createElement("div", { className: "table-responsive" },
                                react_1.default.createElement("table", { className: "table table-sm" },
                                    react_1.default.createElement("thead", null,
                                        react_1.default.createElement("tr", null,
                                            react_1.default.createElement("th", null, "Event"),
                                            react_1.default.createElement("th", null, "Count"))),
                                    react_1.default.createElement("tbody", null,
                                        ((_f = last === null || last === void 0 ? void 0 : last.eventsByNameTop) !== null && _f !== void 0 ? _f : []).map((e) => (react_1.default.createElement("tr", { key: e.event },
                                            react_1.default.createElement("td", null,
                                                react_1.default.createElement("code", null, e.event)),
                                            react_1.default.createElement("td", null, e.count)))),
                                        (!(last === null || last === void 0 ? void 0 : last.eventsByNameTop) || last.eventsByNameTop.length === 0) && (react_1.default.createElement("tr", null,
                                            react_1.default.createElement("td", { colSpan: 2, className: "text-muted" }, "\u2014")))))))))))));
}
// ---- Attachment of network metrics to snapshots ----
function attachNetMetrics(s, rtts, rx, tx) {
    const now = Date.now();
    const horizon = now - 60000; // 60s window
    // purge windows
    while (rx.length && rx[0].ts < horizon)
        rx.shift();
    while (tx.length && tx[0].ts < horizon)
        tx.shift();
    const rxBytes = rx.reduce((acc, x) => acc + x.bytes, 0);
    const txBytes = tx.reduce((acc, x) => acc + x.bytes, 0);
    const rxKbps = (rxBytes * 8) / 1000 / 60; // kb/s
    const txKbps = (txBytes * 8) / 1000 / 60; // kb/s
    const avg = rtts.length ? rtts.reduce((a, b) => a + b, 0) / rtts.length : 0;
    const p95val = p95(rtts);
    return Object.assign(Object.assign({}, s), { rttAvgMs: avg, rttP95Ms: p95val, rxKbps,
        txKbps });
}
